
// assets imports
import { tipoImovelIDFromNome } from "constants/tiposImovel"

export function MapInputsToTaxBody(nameServ, input)
{
    let body = {}

    /* eslint no-fallthrough: ["off", { "allowEmptyCase": true }] */
    
    switch (nameServ)
    {
        case "Alvara":
            return body =
            {
                "areaConstruida": Number(input.areaConstruida),
                "areaTerreno": Number(input.areaTerreno),
                "areaUtil": Number(input.areaUtil),
                "conjuntoHabitacional": input.conjuntoHabitacional,
                "houveInicioDeObra": input.houveInicioDeObra,
                "loteamento": {"areaTerreno": input.areaTerreno},
                "obraEmExecucao": input.obraEmExecucao === "Sim" ? true : false,
                "taxaOcupMenor30": input.taxaOcupMenor30,
                "temAnuencia": input.anuencia,
                "tipo": input.tipoImovel,
                "valorAnuencia": input.valorAnuencia,
                "valorPagoInicioDeObra": input.valorPagoInicioDeObra,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }
            
        case "Anuencia":
            return body =
            {
                "areaConstruida": Number(input.areaConstruida),
                "tipo": input.tipoImovel,
                "areaUtil": input.areaUtil,
                "areaTerreno": input.areaTerreno,
                "temComercio": input.temComercio,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "AlvaraAcresReg":
            return body =
            {
                "tipo": input.tipoImovel,
                "areaAcrescidaMaisReforma": Number(input.areaAcrescida) + Number(input.areaReforma),
                "areaAverbada": input.areaAverbada,
                "areaConstruida": Number(input.areaConstruida),
                "areaNovoUso": input.areaNovoUso,
                "areaRegularizar": input.areaRegularizar,
                "areaTerreno": input.areaTerreno,
                "areaUtil": input.areaUtil,
                "temComercio": input.temComercio,
                "taxaOcupMenor30": input.taxaOcupMenor30,
                "temAnuencia": input.anuencia,
                "valorAnuencia": input.valorAnuencia,
                "outroUso": input.usoAreaAverbada !== input.tipoImovel,
                "qualUso": input.usoAreaAverbada,
                "executadaComLicenca": input.executadaComLicenca,
                "houveInicioDeObra": input.houveInicioDeObra,
                "valorPagoInicioDeObra": input.valorPagoInicioDeObra,
                "obraEmExecucao": input.obraEmExecucao === "Sim" ? true : false,
                "conjuntoHabitacional": input.conjuntoHabitacional,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }
    
        case "AutObrasInfra":
            return body =
            {
                "valorContrato": input.valorContrato,
                "houveInicioDeObra": input.houveInicioDeObra,
                "incluirTaxaProtocolo": true
            }
    
        case "AutERB": case "DeclConcInstERBComAut":
            return body =
            {
                "numEstacoes": input.numEstacoes,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "AutoDeEmbargo": case "ReparosGeraisSemLicenca":
            return body =
            {
                "diasAposVencimento": input.diasAposVencimento,
                "usoComplexo": input.usoComplexo,
                "usoIncomodo": input.usoIncomodo,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "AutoDeInfracao":
            return body =
            {
                "diasAposVencimento": input.diasAposVencimento,
                "usoComplexo": input.usoComplexo,
                "usoIncomodo": input.usoIncomodo,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo,
                "areaDemolidaSemAutorizacao": input.areaDemolidaSemAutorizacao,
                "areaTerreno": input.areaTerreno,
                "areaUtil": input.areaUtil,
                "tipo": input.tipoImovel,
            }

        case "AutRepGerais": case "AutRepGeraisAcess":
            return body =
            {
                "houveInicioDeObra": input.houveInicioDeObra,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "AutDemol": case "CertDemolSemAut":
            return body =
            {
                "areaDemolidaSemAutorizacao": input.areaDemolidaSemAutorizacao,
                "areaTerreno": input.areaTerreno,
                "areaUtil": input.areaUtil,
                "tipo": input.tipoImovel,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "CertRegul":
            const usoAreaAverbada = document.getElementsByName("usoAreaAverbada")[0]
            return body =
            {
                "tipo": input.tipoImovel,
                "areaConstruida": Number(input.areaConstruida),
                "condHor": input.tipoCondominio === "Horizontal",
                "numUnid": Number(input.numUnid),
                "areaTerreno": Number(input.areaTerreno),
                "areaUtil": Number(input.areaUtil),
                "areaAverbada": Number(input.areaAverbadaOuAprovada),
                "areaRegularizar": Number(input.areaRegularizar),
                "areaAverbadaComMudancaDeUso": Number(input.areaAverbadaComMudancaDeUso),
                "novoUso": tipoImovelIDFromNome[usoAreaAverbada?.value],
                "executadaComLicenca": input.executadaComLicenca,
                "atendeAsNormasUrb": input.atendeAsNormasUrb,
                "taxaOcupMenor30": input.taxaOcupMenor30,
                "conjuntoHabitacional": input.conjuntoHabitacional,
                "qtdVistorias": input.qtdVistorias,
                "imovelIsento": input.imovelEhTemplo || input.imovelEhInstituicaoDeCaridade || input.cidadaoBaixaRenda,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }            
    
        case "CertRegulInfra":
            return body =
            {
                "valorContrato": input.valorContrato,
                "houveInicioDeObra": input.houveInicioDeObra,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "DeclConcInstERBSemAut":
            return body =
            {
                "numEstacoes": input.numEstacoes,
                "atendeAsNormasUrb": input.atendeAsNormasUrb,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "ObraIniciadaSemLicenca" :
            return body =
            {
                "areaAcrescida": Number(input.areaAcrescida),
                "areaConstruida": Number(input.areaConstruida),
                "areaTerreno": Number(input.areaTerreno),
                "numEstacoes": Number(input.numEstacoes),
                "areaUtil": Number(input.areaUtil),
                // "qtdDiasAposNotificacao": Number(input.diasAposVencimento),
                "obraEmExecucao": input.obraEmExecucao === "Sim" ? true : false,
                "tipo": input.tipoImovel,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "TermoDemarc":
            return body = 
            {
                "areaTerreno": Number(input.areaTerreno),
                "incluirTaxaDemarcacao": input.incluirTaxaDemarcacao,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "CertHabitese": case "RenHabitese":
            return body =
            {
                "areaConstruida": Number(input.areaConstruida),
                "tipo": input.tipoImovel,
                "numUnid": Number(input.numUnid),
                "condHor": input.tipoCondominio === "Horizontal",
                "temComercio": input.temComercio,
                "qtdVistorias": input.qtdVistorias,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "DeclGLP":
            return body =
            {
                "areaPlataforma": input.areaPlataforma,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }
            

        case "SubsProj":            
            return body =
            {
                "areaConstruida": Number(input.areaConstruida),
                "areaAcrescida": input.areaAcrescida,
                "areaUtil": input.areaUtil,
                "areaUtilAcrescida": input.areaUtilAcrescida,
                "areaTerreno": input.areaTerreno,
                "areaTerrenoAcrescida": input.areaTerrenoAcrescida, //
                "conjuntoHabitacional": input.conjuntoHabitacional, //
                // "temComercio": input.temComercio,
                "tipo": input.tipoImovel,            
                // "valorPagoAlvara": input.valorAlvara,
                "novaTaxaOcupMaior30": input.novaTaxaOcupMaior30,
                "taxaOcupMenor30": input.taxaOcupMenor30,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "TermoDesm": case "TermoRem": case "TermoDesmRem": case "TermoDesmComIncorporacao":
            return body =
            {
                "areaTerreno": Number(input.areaTerreno),
                "areaRemanescente": Number(input.areaRemanescente),
                "possuiDemarcacao": input.possuiDemarcacao,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "TermoVerObras":
            return body =
            {
                "numUnid": input.numUnid,
                "qtdVistorias": input.qtdVistorias,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        case "RenAlvara":
            return body =
            {
                "valorAlvara": input.valorAlvara,
                "incluirTaxaProtocolo": input.incluirTaxaProtocolo
            }

        default: return body = {"incluirTaxaProtocolo": input.incluirTaxaProtocolo}
    }


}